import React, { useMemo } from 'react'
import * as S from 'pages/HomePage/HomePageContainer.styles'
import ArtCollectionHomeUI from './ArtCollectionHomeUI'
import { PlaybackProvider } from 'components/PlaybackProvider/PlaybackContext'
import BrowserThemeColor from 'components/ThemeColor/BrowserThemeColor'
import StickyCta from 'components/StickyCta/StickyCta'
import useScreenSize from 'hooks/useScreenSize'
import TopBar from 'elements/TopBar/TopBar'
import TopBarBanner from 'elements/TopBar/TopBarBanner/TopBarBanner'
import { photosTheme as theme } from 'mixtiles-web-common'
import { ART_COLLECTION_BROWSE_URL } from '../../../config/config'
import { useTranslation } from 'react-i18next'
import { getArtworkThumbnailUrl } from '../../../services/artCollectionService'
import useArtCollectionAnalytics from '../useArtCollectionAnalytics'
import useHomePage from '../../HomePage/useHomePage'
import { SCREENS } from '../../../services/Analytics/Analytics'
import { useArtCollection } from '../ArtCollectionProvider/ArtCollectionProvider'
import { emailCaptureManager } from 'services/EmailCaptureManager'
import { useExperimentManager } from 'services/ExperimentManager/ExperimentManager'
import { getCollectionCategoryFromUrl } from 'services/artCatalogService'
import { genericBannerManager } from '../../../services/GenericBannerManager'

export default function ArtCollectionHome() {
  const isMediumScreen = useScreenSize('md')
  const { getAnalyticsProps } = useArtCollectionAnalytics()
  const { t } = useTranslation()
  const { catalog } = useArtCollection()
  const experimentManager = useExperimentManager()

  const { categoryName, artworkUrls } = useMemo(() => {
    if (!catalog) {
      return { categoryName: null, artworkUrls: [] }
    }
    const isCategoryPage = !!getCollectionCategoryFromUrl()
    const [categoryName, featuredArtworks] = Object.entries(catalog)[0]
    return {
      categoryName: isCategoryPage ? categoryName : null,
      artworkUrls: featuredArtworks.map((artwork) =>
        getArtworkThumbnailUrl(artwork)
      ),
    }
  }, [catalog])

  const { onMainCtaClick } = useHomePage({
    screenName: categoryName
      ? SCREENS.ART_COLLECTION_CATEGORY_PAGE
      : SCREENS.ART_COLLECTION_HOME_PAGE,
    eventProperties: {
      ...getAnalyticsProps(),
      'Category Name': categoryName,
    },
    ctaClickUrl: ART_COLLECTION_BROWSE_URL,
  })

  const TopBarComponent = isMediumScreen
    ? TopBar.TopContent
    : TopBar.BottomContent

  return (
    <S.Container className="HomePage">
      <BrowserThemeColor color={theme.colors.white} />
      <TopBar backgroundColor="transparent">
        <TopBarComponent>
          <TopBarBanner bannerManagerInstance={genericBannerManager} />
        </TopBarComponent>
      </TopBar>
      <StickyCta
        onClick={() => {
          const skipOnboarding =
            emailCaptureManager.passedAnyOnboarding() ||
            experimentManager.isEnabled('art-skip-onboarding')
          onMainCtaClick(!skipOnboarding)
        }}
        text={t('art.home.cta_browse')}
      />
      <PlaybackProvider>
        <ArtCollectionHomeUI
          artworkUrls={artworkUrls}
          categoryName={categoryName}
        />
      </PlaybackProvider>
    </S.Container>
  )
}
